import { render } from "./Si.vue?vue&type=template&id=3d240342"
import script from "./Si.vue?vue&type=script&lang=js"
export * from "./Si.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__